import { majorToMinorUnits } from '@shared/utils/currency/minorUnits';
import { floorFundBalanceToWholeUnits } from './floorFundBalanceToWholeUnits';

/**
 * Smallest saving a promo surface may quote, in the fund's own major units — never converted.
 * A default rather than 0, so the floor holds on surfaces that hold no flag payload to read.
 */
export const DEFAULT_MIN_COUPON_SAVING_MAJOR_UNITS = 10;

/**
 * Whether a saving is big enough to lead with. The AMOUNT decides, never the rate.
 *
 * Compared after `floorFundBalanceToWholeUnits`, so the figure tested is the figure drawn — that
 * helper keeps the cents on a sub-unit amount, which is how a 50-cent saving reached a tile.
 */
export const isCouponSavingWorthShowing = (minorUnits: number | undefined | null, currencyCode: string | undefined | null, minSavingMajorUnits: number): boolean => {
  if (!minorUnits || minorUnits <= 0 || !currencyCode) return false;
  if (minSavingMajorUnits <= 0) return true;

  // Both sides in minor units, so a currency with no decimal places needs no special case.
  return floorFundBalanceToWholeUnits(minorUnits, currencyCode) >= majorToMinorUnits(minSavingMajorUnits, currencyCode);
};
